<template>
  <div
    v-if="fundraiserSearchResults"
    id="search-result"
  >
    <InfiniteScroll :disabled="loading" @load-more="loadMore">
      <div class="header-container-mobile inner-wrap">
        <div id="search-items">
          <component 
            :is="getComponent()"
            v-for="(page, index) of fundraiserSearchResults" 
            :id="index"
            :key="index"
            :page="page"
            :hide-join-team="hideJoinTeam"
          />

          <loader
            :color="spinnerColour"
            :loading="loading"
            size="36px"
          />
        </div>
      </div>
    </InfiniteScroll>
  </div>
</template>

<script>
import Loader from "vue-spinner/src/ClipLoader.vue";
import FundraiserBoxRaise from './FundraiserBoxRaise.vue'
import FundraiserBoxRaiseDesign1 from './FundraiserBoxRaise/Design1.vue'
import FundraiserBoxRaiseDesign2 from './FundraiserBoxRaise/Design2.vue'
import InfiniteScroll from '../InfiniteScroll.vue'

export default {
  name: 'FundraiserBoxRaises',
  components: {
    Loader,
    FundraiserBoxRaise,
    FundraiserBoxRaiseDesign1,
    FundraiserBoxRaiseDesign2,
    InfiniteScroll,
  },
  props: {
    fundraiserSearchResults: {
      type: Array,
      default: () => [],
    },
    loading: {
      type:Boolean,
      default: false,
    },
    spinnerColour: {
      type: String,
      default: '#000',
    },
    hideJoinTeam: {
      type: Boolean,
      default: false,
    },
    design: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const getComponent = () => {
      switch (props.design) {
        case 'design1':
          return 'FundraiserBoxRaiseDesign1'
        case 'design2':
          return 'FundraiserBoxRaiseDesign2'
        default: 
          return 'FundraiserBoxRaise'
      }
    }

    const loadMore = () => {
      emit('loadMore')
    }

    return {
      loadMore,
      getComponent,
    }
  },
}
</script>

<style lang="css" scoped>
 /* get max-width from theme setting */
.inner-wrap {  
  padding: 15px 0;
  margin: 0 auto;  
}

#search-result {
    padding-bottom:50px;
    background: #ffffff;
}

#search-result.ben-search .search-item.appended {
    margin-top:30px;
    opacity:0;
}

div#search-items {
    text-align: center;
    padding: 10px 0 0;
}

div#search-items:after {
    clear: both;
    display: block;
    content: '';
}

</style>